export enum Alerts {
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  PRO = 'pro',
  NEUTRAL = 'neutral',
}
